export enum RequestManpowerAction {
  SAVE = 'SAVE',
  SUBMIT = 'SUBMIT',
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  CANCEL = 'CANCEL'
}
